<ng-container *transloco="let t;">
<div class="col-12 col-lg-12 col-md-12 p-2">
    <h3 class="title-heading-text mt-0 mb-50">{{t('Step title (bulk upload import results steps) - Import results')}}</h3>
    <p class="mb-0">{{t('Step description (bulk upload import results steps) - You can see here the result of the imports')}}.</p>
</div>

 
<div class="col-12 col-lg-12 col-md-12 ps-2 pe-2">
    <hr class="mb-0 mt-0">
</div>

<div class="col-12 col-lg-12 col-md-12 p-0 mt-75 mapping-table">
    <div class="modal-body flex-grow-1 p-0">
        <ul ngbNav #navJustified="ngbNav" class="nav-tabs mx-1" [(activeId)]="activeNav">
            <li [ngbNavItem]="BulkImportSummaryTabEnum.Categories">
                <a ngbNavLink>{{t("Category tab name (bulk upload summary step) - Categories")}} ( {{categories?.length ?? 0 }} )  </a>
                <ng-template ngbNavContent>
                    <ng-scrollbar autoHeightDisabled="false" visibility="hover">
                        <app-table [columns]="categoriesColumns" [data]="categories" [emptyDataTemplate]="emptyValue"></app-table>
                        <ng-template #emptyValue>{{ t('No items table notifications (match contract card steps) - Nothing to show') }}</ng-template>
                    </ng-scrollbar>
                </ng-template>
            </li>
            <li [ngbNavItem]="BulkImportSummaryTabEnum.ContractCards">
                <a ngbNavLink>{{t("Contract control tab name (bulk upload summary step) - Contract Controls")}} ( {{contractCards?.length ?? 0 }} )  </a>
                <ng-template ngbNavContent>
                    <app-table [columns]="contractControlCardsColumns" [data]="contractCards" [emptyDataTemplate]="emptyValue"></app-table>
                    <ng-template #emptyValue>{{ t('No items table notifications (match contract card steps) - Nothing to show') }}</ng-template>
                </ng-template>
            </li>
            <li [ngbNavItem]="BulkImportSummaryTabEnum.Organizations">
                <a ngbNavLink>{{t("Organizations tab name (bulk upload summary step) - Organizations")}} ( {{organizations?.length ?? 0 }} )</a>
                <ng-template ngbNavContent>
                    <app-table [columns]="organizationsColumns" [data]="organizations" [emptyDataTemplate]="emptyValue"></app-table>
                    <ng-template #emptyValue>{{ t('No items table notifications (match contract card steps) - Nothing to show') }}</ng-template>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="navJustified" class="mt-2 mx-1 overflow-auto"></div>
    </div>
</div>









</ng-container>